import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-markdown-preview/markdown.css';

const API_BASE_URL = (process.env.REACT_APP_API_URL || window.location.origin || '').replace(/\/$/, '');

const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState(null);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        let active = true;

        axios.get(`${API_BASE_URL}/api/privacy`)
            .then((res) => {
                if (!active) return;
                setPolicy(res.data);
                setStatus('ready');
            })
            .catch(() => {
                if (!active) return;
                setStatus('error');
            });

        return () => {
            active = false;
        };
    }, []);

    return (
        <main style={styles.page}>
            <section style={styles.shell}>
                <a href="/" style={styles.brandLink} aria-label="Go to HappTrak home">
                    <img src="/happtrak-logo.svg" alt="" style={styles.logo} />
                    <span style={styles.brandName}>HappTrak</span>
                </a>

                <div style={styles.header}>
                    <h1 style={styles.title}>Privacy Policy</h1>
                    {policy?.effective_date && (
                        <p style={styles.meta}>
                            Effective {new Date(policy.effective_date).toLocaleDateString(undefined, {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                            })}
                        </p>
                    )}
                </div>

                {status === 'loading' && <p style={styles.message}>Loading privacy policy...</p>}
                {status === 'error' && (
                    <p style={styles.message}>
                        The privacy policy is not available yet. Please check back soon or contact info@happtrak.ai.
                    </p>
                )}
                {status === 'ready' && (
                    <div data-color-mode="light" style={styles.content}>
                        <MDEditor.Markdown source={policy.content} />
                    </div>
                )}
            </section>
        </main>
    );
};

const styles = {
    page: {
        minHeight: '100vh',
        background: '#f6f8f7',
        color: '#1f2a24',
        padding: '32px 16px',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    shell: {
        width: 'min(880px, 100%)',
        margin: '0 auto',
        background: '#ffffff',
        border: '1px solid #dfe7e2',
        borderRadius: 8,
        padding: '28px',
    },
    brandLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        color: '#1f2a24',
        textDecoration: 'none',
        marginBottom: 28,
    },
    logo: {
        width: 36,
        height: 36,
    },
    brandName: {
        fontSize: 20,
        fontWeight: 800,
    },
    header: {
        borderBottom: '1px solid #e5ebe8',
        marginBottom: 24,
        paddingBottom: 16,
    },
    title: {
        margin: 0,
        fontSize: 34,
        lineHeight: 1.15,
        color: '#132019',
    },
    meta: {
        margin: '8px 0 0',
        color: '#5f6f66',
        fontSize: 14,
    },
    content: {
        fontSize: 16,
        lineHeight: 1.65,
    },
    message: {
        color: '#4d5d54',
        fontSize: 16,
        lineHeight: 1.6,
    },
};

export default PrivacyPolicy;
